import {
    addServicesRequest,
    deleteServicesRequest,
    editServicesRequest,
    getServicesListRequest,
    getServicesRequest,
    updateServicesRequest,
} from '../../../../services/network/region_services/services';

class CommonServicesService {
    async addServices(values) {
        return await addServicesRequest(values);
    }

    async getServices(id) {
        return await getServicesRequest(id);
    }

    async getServicesList(payload) {
        return await getServicesListRequest(payload);
    }

    async deleteServices(id) {
        return await deleteServicesRequest(id);
    }

    async editServices(updates) {
        return await editServicesRequest(updates);
    }

    async updateServices(updates) {
        return await updateServicesRequest(updates);
    }
}

export const ServicesService = new CommonServicesService();
